<section class="hero-section">
  <div class="hero-carousel">
    @for (slide of slides; track slide; let i = $index) {
      <div
        class="hero-slide"
        [ngClass]="{ 'active': i === currentSlide }">
        <div class="desktop-image" [style.backgroundImage]="'url(' + slide.image + ')'"></div>
        <div class="mobile-image" [style.backgroundImage]="'url(' + slide.mobileImage + ')'"></div>
        <div class="hero-content">
          <div class="hero-text">
            <h1 class="hero-title">{{ slide.title | translate }}</h1>
            <p class="hero-description">{{ slide.description | translate }}</p>
            <button class="btn-cta">{{ slide.ctaText | translate }}</button>
          </div>
        </div>
      </div>
    }

    <!-- Navigation Buttons -->
    <button class="nav-btn nav-prev" (click)="prevSlide()" aria-label="Previous slide">&#10094;</button>
    <button class="nav-btn nav-next" (click)="nextSlide()" aria-label="Next slide">&#10095;</button>

    <!-- Indicators -->
    <div class="hero-indicators">
      @for (slide of slides; track slide; let i = $index) {
        <button
          class="indicator"
          [ngClass]="{ 'active': i === currentSlide }"
          (click)="goToSlide(i)"
          [attr.aria-label]="'Go to slide ' + (i + 1)">
        </button>
      }
    </div>
  </div>
</section>